export const trimAddress = (address, leftLength = 6, rightLength = 5) => address ? `${address?.slice(0, leftLength)}....${address?.slice(-rightLength)}` : "";
//# sourceMappingURL=trimAddress.js.map